<template>
  <div>
    <autocomplete-input
      v-if="!hideSupplier"
      :path="'/suppliers'"
      :name="'supplier'"
      :label="'name'"
      loadOnFocus
      :outValKey="true"
      :isObject="true"
      :optionsV="fobPoint.supplier && fobPoint.supplier.length ? fobPoint.supplier : []"
      :track-by="'psCode'"
      v-validate="`required`"
      v-model="fobPoint.supplierCode"
    />
    <validated-input v-model="fobPoint.fobId" validate="required" label="Fob Id" v-validate="`required`" />
    <address-fields
      v-model="fobPoint"
      :is-city-required="shippingRequired"
      :is-state-required="isStateRequired"
      :is-country-required="shippingRequired"
      :is-zip-required="shippingRequired"
      :hide="['street2']"
    />
  </div>
</template>
<script>
import { stateRequired } from '../utils';
export default {
  inject: ['$validator'],
  name: 'FobPointFormElement',
  props: {
    fobPoint: { type: Object },
    hideSupplier: { type: Boolean },
    shippingRequired: { type: Boolean, default: () => false }
  },
  computed: {
    isStateRequired() {
      return stateRequired(this.fobPoint);
    }
  }
};
</script>
